module.exports = __webpack_public_path__ + "img/bottle.df112d4d.png";